// Note: The first file of a module here, must also register the module

import "./badge-number-Help.component";
import "./bulk-actions.component";
import "./bulk-delete.component";
import "./bulk-edit.component";
import "./people.controller";
import "./people-add-location.component";
import "./people-pane.component";
import "./people-tabs.component";
